export default "__VITE_ASSET__DqQ_o1E9__"